import httpAuth from '@/services/httpAuth'
import { serialize } from '@/services/object'

let infoData = false
export async function info () {
  if (!infoData) infoData = await httpAuth.get(`/acessomodulo/info`, { tela: 'acesso_modulo' })
  return infoData
}

export async function list (filtros) {
  return httpAuth.get(`/acessomodulo?${serialize(filtros)}`, { tela: 'acesso_modulo' })
}

export async function get (id) {
  return httpAuth.get(`/acessomodulo/${id}`, { tela: 'acesso_modulo' })
}

export async function add (dados) {
  return httpAuth.post(`/acessomodulo`, dados, { funcionalidade: 'acesso_modulo_incluir' })
}

export async function edit (id, dados) {
  return httpAuth.put(`/acessomodulo/${id}`, dados, { funcionalidade: 'acesso_modulo_editar' })
}

export async function del (id) {
  return httpAuth.delete(`/acessomodulo/${id}`, { funcionalidade: 'acesso_modulo_excluir' })
}
